var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  DataStub: () => DataStub,
  default: () => stdin_default
});
module.exports = __toCommonJS(stdin_exports);
var import_tslib = require("tslib");
var import_omit = __toESM(require("lodash/omit"));
var import_defaults = require("./defaults");
var import_getPatchedDataSchema = __toESM(require("./getPatchedDataSchema"));
var import_isNonNullable = require("./utils/isNonNullable");
var import_path = require("./utils/path");
var import_eval = require("./utils/eval");
var import_defineLazyGetter = require("./utils/defineLazyGetter");
var _DataStub_objCachedChildStub;
const defaultLoremFunction = (schema) => {
  if (schema.type === "string")
    return "Lorem Ipsum";
  if (schema.type === "integer")
    return 123;
  if (schema.type === "number")
    return 123;
  if (schema.type === "boolean")
    return true;
  return null;
};
class DataStub {
  constructor(options) {
    var _a, _b, _c, _d, _e, _f, _g;
    this.watchers = [];
    _DataStub_objCachedChildStub.set(this, void 0);
    this.context = (_c = (_a = options.context) !== null && _a !== void 0 ? _a : (_b = options.parent) === null || _b === void 0 ? void 0 : _b.context) !== null && _c !== void 0 ? _c : import_defaults.defaults.context;
    this.exprContext = (_d = options.exprContext) !== null && _d !== void 0 ? _d : (_e = options.parent) === null || _e === void 0 ? void 0 : _e.exprContext;
    this.parent = options.parent;
    this.isRootStub = !this.parent;
    this.id = this.isRootStub ? void 0 : options.id;
    this.schema = Object.freeze((0, import_getPatchedDataSchema.default)(options.schema));
    if (this.isRootStub) {
      if (!(0, import_isNonNullable.isNullish)(this.schema.id))
        this.schema = (0, import_omit.default)(this.schema, ["id"]);
    } else {
      if ((0, import_isNonNullable.isNullish)(this.id))
        throw new Error("id is required for sub DataStub");
      if (this.schema.id !== this.id)
        this.schema = Object.assign(Object.assign({}, this.schema), { id: this.id });
    }
    this.type = this.schema.type;
    this.isVolatile = !!(!this.schema.enum && this.schema.enumExpr || this.type === "object" && (((_f = this.schema.groups) === null || _f === void 0 ? void 0 : _f.some((x) => x.condition)) || this.definedFields.some((x) => x.condition)));
    if (this.parent) {
      if (options.pathParts)
        throw new Error("cannot set pathParts if DataStub has a parent");
      this.pathParts = this.parent.pathParts.slice();
      if (!this.isRootStub)
        this.pathParts.push(this.id);
    } else {
      this.pathParts = ((_g = options.pathParts) === null || _g === void 0 ? void 0 : _g.slice()) || [];
    }
    this.path = (0, import_path.joinPath)(this.pathParts);
    if (this.isRootStub) {
      this.root = this;
      this.internalRootValue = options.value;
    } else {
      this.root = this.parent.root;
    }
  }
  getValue() {
    if (this.isRootStub)
      return this.internalRootValue;
    const { pathParts, root } = this;
    let ptr = root.value;
    for (let i = root.pathParts.length; i < pathParts.length; i++) {
      if (typeof ptr !== "object" || ptr === null)
        break;
      const k = pathParts[i];
      ptr = ptr[k];
    }
    return ptr;
  }
  setValue(value) {
    this.handleSelfMutation(this.value, value, []);
  }
  get value() {
    return this.getValue();
  }
  set value(v) {
    this.setValue(v);
  }
  getSchema() {
    return this.schema;
  }
  handleBubbledMutation(trace) {
    const { immutable } = this.context;
    const lastMut = trace[trace.length - 1];
    const id = lastMut.id;
    const oldValue = this.value;
    const oldValueIsNullish = !oldValue;
    if (immutable) {
      const clone = this.type === "array" ? oldValueIsNullish ? [] : [...oldValue] : Object.assign({}, oldValue);
      clone[id] = lastMut.value;
      this.handleSelfMutation(oldValue, clone, trace);
    } else {
      const clone = oldValueIsNullish ? oldValue : this.type === "array" ? [...oldValue] : Object.assign({}, oldValue);
      if (clone)
        clone[id] = lastMut.oldValue;
      let midValue = oldValue;
      if (oldValueIsNullish) {
        if (this.type === "array")
          midValue = [];
        else
          midValue = {};
      }
      if (midValue[id] !== lastMut.value) {
        this.context.set(midValue, id, lastMut.value);
      }
      this.handleSelfMutation(clone, midValue, trace);
    }
  }
  handleSelfMutation(oldValue, newValue, prevTrace) {
    const trace = [
      ...prevTrace,
      {
        oldValue,
        value: newValue,
        id: this.id,
        path: this.path,
        pathParts: this.pathParts
      }
    ];
    if (!this.isRootStub) {
      this.parent.handleBubbledMutation(trace);
      return;
    }
    this.internalRootValue = newValue;
    this.watchers.forEach((watcher) => {
      const { pathParts } = watcher;
      const trigged = pathParts.length <= trace[0].pathParts.length && pathParts.every((p, i) => p == trace[0].pathParts[i]);
      if (!trigged)
        return;
      const zDelta = trace[0].pathParts.length - pathParts.length;
      const tracePt = trace[zDelta];
      watcher.callback(tracePt.value, tracePt.oldValue, trace);
      if (watcher.once)
        watcher.remove();
    });
  }
  getChildStub(id) {
    switch (this.type) {
      case "object": {
        if (!(0, import_tslib.__classPrivateFieldGet)(this, _DataStub_objCachedChildStub, "f"))
          (0, import_tslib.__classPrivateFieldSet)(this, _DataStub_objCachedChildStub, {}, "f");
        if (id in (0, import_tslib.__classPrivateFieldGet)(this, _DataStub_objCachedChildStub, "f"))
          return (0, import_tslib.__classPrivateFieldGet)(this, _DataStub_objCachedChildStub, "f")[id];
        const { definedFields, additionalFields } = this;
        const indexInDefinedFields = definedFields.findIndex((x) => x.id === id);
        const fieldSchema = indexInDefinedFields >= 0 ? definedFields[indexInDefinedFields] : additionalFields;
        if (!fieldSchema)
          return null;
        const stub = new DataStub({ schema: fieldSchema, parent: this, id });
        if (indexInDefinedFields >= 0 && stub)
          (0, import_tslib.__classPrivateFieldGet)(this, _DataStub_objCachedChildStub, "f")[id] = stub;
        return stub;
      }
      case "array": {
        const itemSchema = this.schema.items;
        const index = +id;
        if (Number.isNaN(index) || +id < 0)
          return null;
        return new DataStub({ schema: itemSchema, parent: this, id: index });
      }
      default: {
        return null;
      }
    }
  }
  getStubAtPath(path) {
    let ptr = this;
    const parts = (0, import_path.toPathParts)(path);
    while (ptr && parts.length) {
      ptr = ptr.getChildStub(parts.shift());
    }
    return ptr;
  }
  setChildValue(key, childValue, trace) {
    const subStub = this.getChildStub(key);
    subStub.handleSelfMutation(subStub.value, childValue, trace || []);
  }
  watch(path, callback, { once = false } = {}) {
    const { root } = this;
    const pathParts = [...this.pathParts, ...(0, import_path.toPathParts)(path)];
    const remove = () => {
      const idx = root.watchers.indexOf(it);
      if (idx >= 0)
        root.watchers.splice(idx, 1);
    };
    const it = {
      pathParts,
      callback,
      once,
      remove
    };
    root.watchers.push(it);
    return remove;
  }
  getDefaultValue(opts) {
    var _a;
    const { schema } = this;
    if (!(0, import_isNonNullable.isUndefined)(schema.default)) {
      return (0, import_eval.processMaybeExpr)(schema.default, this, this.exprContext);
    }
    const enums = this.getEnums();
    if (enums === null || enums === void 0 ? void 0 : enums[0])
      return enums[0].value;
    const { useLorem, useExample, mockArrayItems } = opts || {};
    const loremFn = useLorem && (typeof useLorem === "function" ? useLorem : defaultLoremFunction);
    if (useExample) {
      if (!(0, import_isNonNullable.isUndefined)(schema.example))
        return schema.example;
      if ((_a = schema.examples) === null || _a === void 0 ? void 0 : _a.length)
        return schema.examples[0].value;
    }
    switch (schema.type) {
      case "string":
        return loremFn ? loremFn(this.schema) : "";
      case "boolean":
        return loremFn ? loremFn(this.schema) : false;
      case "integer":
      case "number":
        return loremFn ? loremFn(this.schema) : 0;
      case "array": {
        const length = (mockArrayItems && typeof mockArrayItems !== "number" ? 3 : mockArrayItems) || 0;
        return Array.from({ length }, (_, i) => this.getChildStub(i).getDefaultValue(opts));
      }
      case "object": {
        const ans = {};
        const { fields, candidates } = this.getFields({ ignoreCondition: opts === null || opts === void 0 ? void 0 : opts.ignoreCondition });
        const populate = (field) => {
          const stub = this.getChildStub(field.id);
          if (!stub)
            return;
          ans[field.id] = stub.getDefaultValue(opts);
        };
        fields.forEach(populate);
        if (opts === null || opts === void 0 ? void 0 : opts.includeOptional)
          candidates.forEach(populate);
        return ans;
      }
      case "null":
      case "any":
      default:
        return loremFn ? loremFn(this.schema) : null;
    }
  }
  getEnums() {
    const { schema } = this;
    if (schema.enum)
      return schema.enum;
    if (schema.enumExpr)
      return (0, import_eval.tryEvalExpr)(schema.enumExpr, null, this, this.exprContext) || null;
    return null;
  }
  getTitle() {
    if (this.schema.title)
      return this.schema.title;
    if (typeof this.id === "string")
      return this.id;
    if (typeof this.id === "number")
      return `\u6570\u7EC4\u9879#${this.id}`;
    return "";
  }
  getSummary() {
    var _a;
    const { value, type } = this;
    if (type === "array") {
      return `[ ${(_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0} \u4E2A${this.arrItems.title || "\u5143\u7D20"} ]`;
    }
    if (type === "object") {
      const firstField = this.getFields().fields.find((field) => /^(?:string|boolean|number|integer)$/.test(field.type));
      if (!firstField)
        return "{ ... }";
      const id = firstField.id;
      return `{ ${id}: ${String(value === null || value === void 0 ? void 0 : value[id]).substr(0, 32)} ... }`;
    }
    const ans = String(value);
    if (ans.length > 32)
      return `${ans.substr(0, 32)}...`;
    return ans;
  }
  toString() {
    return `[DataStub @ ${this.path}: ${this.getSummary()}]`;
  }
  get primaryKey() {
    var _a;
    if (this.type !== "object")
      return void 0;
    return (_a = this.definedFields.find((x) => x.required && x.isPrimaryKey)) === null || _a === void 0 ? void 0 : _a.id;
  }
  get definedFields() {
    return this.schema.fields;
  }
  get additionalFields() {
    return this.schema.additionalFields;
  }
  getFields(opts) {
    if (this.type !== "object")
      throw new Error("The schema type of current stub is not object");
    const { value, definedFields, additionalFields } = this;
    let fields = [...definedFields];
    const candidates = [];
    if (this.isVolatile && !(opts === null || opts === void 0 ? void 0 : opts.ignoreCondition)) {
      const { groups } = this.schema;
      fields = fields.filter((x) => {
        if (typeof x.condition === "string" && !(0, import_eval.tryEvalExpr)(x.condition, false, this, this.exprContext))
          return false;
        const group = !!x.group && groups && groups.find((g) => g.id === x.group);
        if (group && group.condition && !(0, import_eval.tryEvalExpr)(group.condition, false, this, this.exprContext))
          return false;
        return true;
      });
    }
    const allKeys = new Set(value && typeof value === "object" && Object.keys(value) || []);
    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      const id = field.id;
      const isInKeys = allKeys.has(id);
      if (!isInKeys && !field.required) {
        fields.splice(i, 1);
        candidates.push(field);
        i -= 1;
      }
      if (isInKeys)
        allKeys.delete(id);
    }
    if (additionalFields) {
      allKeys.forEach((id) => {
        fields.push(Object.assign(Object.assign({}, additionalFields), { id }));
      });
      allKeys.clear();
    }
    return { fields, candidates };
  }
  set(fieldId, value) {
    if (this.type !== "object" && this.type !== "array")
      throw new Error("Only object or array support this method");
    if (this.type === "array") {
      fieldId = +fieldId;
      if (Number.isNaN(fieldId) || fieldId < 0)
        throw new Error("Index is illegal");
    }
    this.setChildValue(fieldId, value);
  }
  delete(fieldId) {
    if (this.type !== "object")
      throw new Error("Only object support this method");
    const oldVal = this.value;
    if (typeof oldVal !== "object" || oldVal === null || !Object.prototype.hasOwnProperty.call(oldVal, fieldId))
      return;
    const newVal = this.prepareValueForChange(oldVal);
    this.context.delete(newVal, fieldId);
    this.setValue(newVal);
  }
  get arrItems() {
    return this.schema.items;
  }
  get length() {
    var _a;
    return +((_a = this.value) === null || _a === void 0 ? void 0 : _a.length) || 0;
  }
  getArrayItemDefaultValue(opts) {
    var _a, _b;
    return (_b = this.getChildStub(+((_a = this.value) === null || _a === void 0 ? void 0 : _a.length) || 0)) === null || _b === void 0 ? void 0 : _b.getDefaultValue(opts);
  }
  _mutateArray(op) {
    if (this.type !== "array")
      throw new Error("Only array can use this method");
    const mutatedTarget = this.prepareValueForChange();
    const ans = op(mutatedTarget);
    this.setValue(mutatedTarget);
    return ans;
  }
  push(...items) {
    return this._mutateArray((x) => x.push(...items));
  }
  pop() {
    return this._mutateArray((x) => x.pop());
  }
  shift() {
    return this._mutateArray((x) => x.shift());
  }
  splice(...args) {
    return this._mutateArray((x) => x.splice(...args));
  }
  unshift(...items) {
    return this._mutateArray((x) => x.unshift(...items));
  }
  prepareValueForChange(oldValue = this.value) {
    const { immutable } = this.context;
    switch (this.schema.type) {
      case "array":
        if (!Array.isArray(oldValue))
          return [];
        return immutable ? [...oldValue] : oldValue;
      case "object":
        if (typeof oldValue !== "object" || oldValue === null)
          return this.getDefaultValue();
        return immutable ? Object.assign({}, oldValue) : oldValue;
      default:
        return oldValue;
    }
  }
}
_DataStub_objCachedChildStub = /* @__PURE__ */ new WeakMap();
(0, import_tslib.__decorate)([
  (0, import_defineLazyGetter.LazyGetter)()
], DataStub.prototype, "primaryKey", null);
var stdin_default = DataStub;
